<nb-layout>
  <nb-layout-column class="nb-layout-fullscreen">
    <router-outlet></router-outlet>
  </nb-layout-column>
</nb-layout>
